export default __webpack_public_path__ + "static/media/trash-can.9047b678.svg";